import {useState} from 'react'

import {fetchFile} from '@/utils/frontendHelper'
import {routeTo} from '@/utils/router'

import {DocumentLocation} from '../document/types'

export const useFileFetch = () => {
  const [error, setError] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [blob, setBlob] = useState<Blob | null>(null)
  const [filename, setFilename] = useState<string | null>(null)

  const downloadAction = async (document: DocumentLocation) => {
    try {
      setIsLoading(true)
      const response = await fetchFile(routeTo.api.document.id.index(document.hubId, document.id))
      if (response.blob) {
        setBlob(response.blob)
        setFilename(response.filename)
      } else {
        setError('Error downloading file')
      }
    } catch (e) {
      setError(e?.message ?? 'Error downloading file')
    } finally {
      setIsLoading(false)
    }
  }

  return {blob, error, isLoading, downloadAction, filename}
}
